import { cn } from "@/lib/utils";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { Spinner } from "./spinner";
import { CollapsibleTrigger } from "./ui/collapsible";
import { HoverCardTrigger } from "./ui/hover-card";

export function AiTrigger(props: {
  loading: boolean;
  summarizable: boolean;
  setHoverOpen: (open: boolean) => void;
  mobile?: boolean;
}) {
  return (
    <>
      {props.mobile ? (
        <CollapsibleTrigger className="rounded-full bg-white p-1 shadow-lg ring-1">
          {props.loading ? (
            <Spinner size={18} className="mt-1" />
          ) : (
            <PsychologyIcon
              className={cn(
                props.summarizable
                  ? "text-indigo-500"
                  : "text-muted-foreground",
              )}
            />
          )}
        </CollapsibleTrigger>
      ) : (
        <HoverCardTrigger
          asChild
          className=""
          onMouseEnter={() => {
            props.setHoverOpen(true);
          }}
          onMouseLeave={() => {
            props.setHoverOpen(false);
          }}
        >
          <CollapsibleTrigger>
            {props.loading ? (
              <Spinner size={18} className="mt-1" />
            ) : (
              <PsychologyIcon
                className={cn(
                  props.summarizable
                    ? "text-indigo-500"
                    : "text-muted-foreground",
                )}
              />
            )}
          </CollapsibleTrigger>
        </HoverCardTrigger>
      )}
    </>
  );
}
